
import OpacityComponent from "../util/OpacityComponent";
import Physiontherapie1 from "../util/Physiontherapie1";

export default function Ergothrapie(){
    return(
        <div className="w-full overflow-hidden ">
        <Physiontherapie1/>
        <OpacityComponent top="none"/>
    </div>
    )
}